import React, { FocusEvent, useMemo, useState } from 'react';
import { TextField } from '@mui/material';
import { CustomTextFieldProps } from './CustomTextField.props';

const CustomTextField = (props: CustomTextFieldProps) => {
  const { id, type, name, label, value, onChange, formErrors, dbErrors, onBlur, onFocus, ...restProps } = props;
  const [wasFocused, setWasFocused] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const errors = useMemo(() => {
    if (formErrors) {
      const tmpErrors = [];

      if (formErrors[name]) {
        tmpErrors.push(...(Array.isArray(formErrors[name]) ? formErrors[name] : [formErrors[name]]));
      }

      if (dbErrors?.[name]) {
        tmpErrors.push(formErrors[name]);
      }
      return tmpErrors.length ? tmpErrors.join('. ') : '';
    }
    return '';
  }, [formErrors, dbErrors, name]);

  const onInputFocus = (e: FocusEvent<HTMLInputElement>) => {
    setIsEditing(true);
    setWasFocused(true);

    onFocus?.(e);
  };

  const onInputBlur = (e: FocusEvent<HTMLInputElement>) => {
    setIsEditing(false);

    onBlur?.(e);
  };

  return (
    <TextField
      id={id}
      name={name}
      label={label}
      onChange={onChange}
      value={value}
      error={!isEditing && wasFocused && !!errors}
      helperText={!isEditing && wasFocused && errors}
      onFocus={onInputFocus}
      onBlur={onInputBlur}
      autoComplete="off"
      type={type || 'text'}
      {...restProps}
    />
  );
};

export default CustomTextField;
